import React from 'react';
import {createRoot} from 'react-dom/client';
import { Provider } from 'react-redux';
import { store, persistor } from './reduxcomponents/store';
import { PersistGate } from 'redux-persist/integration/react';
import './assets/index.scss';
import App from './App';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// Fix for ResizeObserver loop completed with undelivered notifications
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) return;
        try {
          callback(entries, observer);
        } catch (e) {
          console.error('ResizeObserver callback failed:', e);
        }
      });
    });
  }
};

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
       <App />
     </PersistGate>
   </Provider>, 
);
